/**
 * actions
 *
 * @Author  Carey.zhou
 * @DATE    create on 2019/9/16
 * @DESC
 */
import { SET_QUERY_PARAM } from './types'

export const actions = {

  /**
   * 设置查询参数
   * @param commit
   * @param queryParam  {vno, startDate, endDate}
   */
  setQueryParam ({ commit }, queryParam) {
    commit(SET_QUERY_PARAM, queryParam)
  }

}
